<template>
  <div>
    <div class="paragraph">
      项目结束后，未中标供应商可申请退回保证金，申请后5日内有息退款。成交供应商支付完平台服务费，可申请退回保证金。
    </div>
    <div class="paragraph">
      流标项目，系统自动在流标当天申请退回。
    </div>
    <div class="paragraph">
      如果保证金退款状态为已冻结，则需联系项目负责人协商解冻后，才可退回。
    </div>
  </div>
</template>

<script>
export default {
  name: 'GFeeBackRuleCopywriter'
}
</script>

<style lang="scss" scoped>
.paragraph {
  text-indent: 2em;
}
</style>
